(function () {
  'use strict';

  angular.module('app').component('hotelRoomList', hotelRoomList());

  function hotelRoomList() {
    return {
      bindings: {
        items: '=',
        hotel: '=',
        onHotelRoomDeleted: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: HotelRoomListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-rooms/hotel-room-list/hotel-room-list.component.html',
    };
  }

  HotelRoomListComponent.$inject = ['UtilService', 'HotelRoomService'];

  function HotelRoomListComponent(UtilService, HotelRoomService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = HotelRoomService.getFilterCriteria();

    // Methods
    // vm.fetchResult           = fetchResult;
    // vm.refresh               = refresh;
    // vm.onSort                = onSort;
    vm.addHotelRoomDetail = addHotelRoomDetail;
    vm.showHotelRoomDetail = showHotelRoomDetail;
    vm.changeHotelRoomStatus = changeHotelRoomStatus;
    vm.deleteHotelRoom = deleteHotelRoom;

    vm.$onInit = function () {
      vm.item = vm.UtilService.cleanItemsCache(vm.items, 'logo');
    };

    /*function fetchResult() {
            vm.loadingHotelRooms = true;
            HotelRoomService.getHotelRooms(vm.hotel.id, vm.filterCriteria).then(function () {
                vm.items = HotelRoomService.items;

                vm.loadingHotelRooms = false;
            });
        }

        // refresh the data with the default filter criteria
        function refresh() {
            vm.filterCriteria = HotelRoomService.getFilterCriteria();
            fetchResult();
        }

        function onSort(sortedBy, sortDir) {
            vm.filterCriteria = {
                page: 1,
                sortDir: sortDir,
                sortedBy: sortedBy
            };

            fetchResult();
        }*/

    function addHotelRoomDetail() {
      var successCallback = function (data) {
        vm.items.push(data);
      };

      HotelRoomService.openHotelRoomDetailModal(
        {},
        'create',
        vm.hotel,
        vm.defaultLanguage,
        vm.additionalLanguages,
        successCallback
      );
    }

    function showHotelRoomDetail(room, mode) {
      HotelRoomService.openHotelRoomDetailModal(
        room,
        mode,
        vm.hotel,
        vm.defaultLanguage,
        vm.additionalLanguages
      );
    }

    function changeHotelRoomStatus(item) {
      HotelRoomService.changeHotelRoomStatus(item, vm.hotel.id);
    }

    function deleteHotelRoom(item, index) {
      var successCallback = function (hotel) {
        vm.onHotelRoomDeleted({ hotel: hotel });

        vm.items.splice(index, 1);
      };

      HotelRoomService.deleteHotelRoom(item, vm.hotel.id, successCallback);
    }
  }
})();
